import { SearchParams } from './types';

const AUDIENCE_PARAMS_KEY = 'adCampaign.audienceParams';

export function setAudienceParams(params: Partial<SearchParams>): void {
  try {
    localStorage.setItem(AUDIENCE_PARAMS_KEY, JSON.stringify(params ?? {}));
  } catch {

  }
}

export function getAudienceParams(): Partial<SearchParams> {
  try {
    return JSON.parse(localStorage.getItem(AUDIENCE_PARAMS_KEY) ?? '{}');
  } catch {
    return {};
  }
}

export function clearAudienceParams(): void {
  try {
    localStorage.removeItem(AUDIENCE_PARAMS_KEY);
  } catch {

  }
}

export function clearAudienceData(): void {
  $('#ad-campaign-modal-body').removeAttr('data-audience-id');
  $('#ad-campaign-modal-body').removeAttr('data-audience-name');
  clearAudienceParams();
}
